<template>
  <el-menu
    active-text-color="#1B994F"
    unique-opened
    :default-active="active"
  >
    <el-menu-item
      v-for="(item, index) in items"
      :key="index"
      :index="item.firmId.toString()"
      @click="onCategoryCode(item.firmId)"
    >
      <span>{{ item.firmName }}<i class="count">({{ item.count }})</i></span>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: 'ProductCategoryVerticalSelect',
  props: ['active', 'type'],
  computed: {
    items() {
      return this.$store.state.product.firm.firmCategory
    }
  },
  methods: {
    onCategoryCode(firmId) {
      this.$emit('selected', firmId)
    }
  }
}
</script>

<style lang="less">
li.el-submenu {
  .el-submenu__title {
    font-size: 15px;
    color: #606060;
  }
}
li.el-submenu.is-active.is-opened {
  .el-submenu__title {
    font-weight: bold;
    color: #333333;
  }
}
li.el-menu-item.is-active {
  color: #1b994f;
  font-weight: bold;
}
li.el-submenu > ul > li > .active {
  display: inline-block;
  width: 4px;
  height: 30px;
}
li.el-submenu > ul > li.is-active > .active {
  display: inline-block;
  width: 4px;
  height: 30px;
  background: rgba(27, 153, 79, 1);
  border-radius: 0px 5px 5px 0px;

  position: relative;

  left: -40px;

}
.count{
  font-size: 13px;
  font-style: normal;
}
</style>

<style lang="less" scoped>
.index {
  width: 200px;
  .nav {
    .item {
      background: #3a8b65;

      color: white;

      .children {
        background: white;
        color: #333;
      }
    }
  }
}
</style>
